"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductInventoryStatus = void 0;
var ProductInventoryStatus;
(function (ProductInventoryStatus) {
    ProductInventoryStatus["UNDEFINED"] = "undefined";
    ProductInventoryStatus["BALANCED"] = "balanced";
    ProductInventoryStatus["NET_POSITIVE"] = "net-positive";
    ProductInventoryStatus["NOT_BALANCED"] = "not-balanced";
})(ProductInventoryStatus = exports.ProductInventoryStatus || (exports.ProductInventoryStatus = {}));
//# sourceMappingURL=product-inventory-status.enum.js.map